import {IUpdateError, UPDATE_ERROR} from './types/error.types';
import type {TypedTranslation} from '../../i18n';

export const updateErrorAction = (status: string, message: TypedTranslation, raw: object): IUpdateError => ({
    type: UPDATE_ERROR,
    error: {
        status,
        message,
        raw,
    },
});
